import * as Sentry from '@sentry/react'

import { createRoot } from 'react-dom/client'

import './index.css'
import './polyfills'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { Root } from './containers/Root'

import * as serviceWorker from './serviceWorker'
import React from 'react'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://3568a71ffd7207172c709fcaa6b8d231@o4505702921076736.ingest.us.sentry.io/4509513119956992',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: import.meta.env.VITE_APP_STAGE,
  })
}

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

const root = createRoot(container)
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()

// Set up hot reloading
// if (module.hot) {
//   module.hot.accept('./containers/Root', () => {
//     const NextRoot = require('./containers/Root').default
//     ReactDOM.render(<NextRoot />, document.getElementById('root'))
//   })
// }
